import { kbLog } from './keyboardReframeDebug';

/**
 * The page GLIDE-BACK in flight (inline keyboard guard, 2026-10-22 review):
 * a "restore" scroller (a page) smooth-scrolls back to its pre-reveal top on
 * keyboard close, and its spacer (live or parked) may only drop once that
 * glide has landed (SPACER_RELEASE_DELAY_MS) — dropping it mid-glide shrinks
 * scrollHeight and clamps scrollTop (a snap).
 *
 * Tracked so that
 *  - the keyboard-close SETTLE (inlineKeyboardSettle) skips that scroller —
 *    the two motions must never fight over one scrollTop;
 *  - a re-reveal on the SAME scroller before the glide lands (tap field B
 *    within the glide) cancels the pending release (the old blind timer
 *    dropped B's spacer mid-reveal / mid-glide) and inherits the TRUE resting
 *    top, so B's close glides all the way back in one motion.
 */
let glide = null; // { scroller, beforeTop, timer }

/** Start tracking a glide-back; `release` runs once it has landed. */
export function startRestoreGlide(scroller, beforeTop, release, delayMs) {
  cancelRestoreGlide();
  const g = { scroller, beforeTop, timer: 0 };
  g.timer = setTimeout(() => {
    if (glide === g) glide = null;
    release(scroller);
  }, delayMs);
  glide = g;
}

/** The scroller whose glide-back is in flight, or null. */
export function restoreGlideScroller() {
  return glide ? glide.scroller : null;
}

/**
 * A new reveal targets `scroller`: if its glide-back is in flight, cancel the
 * pending release (the new reveal owns the spacer now) and return the glide's
 * resting top. Null otherwise.
 */
export function takeRestoreGlide(scroller) {
  const g = glide;
  if (!g || g.scroller !== scroller) return null;
  clearTimeout(g.timer);
  glide = null;
  kbLog('inlineRevealGlideTakeover', { beforeTop: g.beforeTop });
  return g.beforeTop;
}

/** Drop tracking without releasing (teardown). */
export function cancelRestoreGlide() {
  if (glide) clearTimeout(glide.timer);
  glide = null;
}
